
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("irxfF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $52EPl = parcelRequire("52EPl");

var $ahaN7 = parcelRequire("ahaN7");


var $dh538 = parcelRequire("dh538");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");

const $bdcc218e6a1dcb18$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $bdcc218e6a1dcb18$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $fRta5.AD_CONTROL_DROP_DOWN_MENU_OPENED) : (0, $fRta5.AD_CONTROL_DROP_DOWN_MENU_CLOSED), createInteractedUIEvent($bdcc218e6a1dcb18$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-growth-trai'),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $bdcc218e6a1dcb18$export$2e2bcd8739ae039 = $bdcc218e6a1dcb18$var$AdControlDropdownMenu;
module.exports["default"] = $bdcc218e6a1dcb18$export$2e2bcd8739ae039;

});

parcelRegister("fRta5", function(module, exports) {
// ACT Event types
// AdControlDropdownMenu
const $6a9218f106f63d94$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $6a9218f106f63d94$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $6a9218f106f63d94$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $6a9218f106f63d94$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $6a9218f106f63d94$export$6d3088110036f124 = 'DISMISS_FAILED';
const $6a9218f106f63d94$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $6a9218f106f63d94$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $6a9218f106f63d94$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $6a9218f106f63d94$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';
module.exports["AD_CONTROL_DROP_DOWN_MENU_OPENED"] = $6a9218f106f63d94$export$17ff257e1f6e39f5;
module.exports["AD_CONTROL_DROP_DOWN_MENU_CLOSED"] = $6a9218f106f63d94$export$7fc09cf740f33ed4;
module.exports["DISMISS_STARTED"] = $6a9218f106f63d94$export$e33200507ac1d20a;
module.exports["DISMISS_SUCCEEDED"] = $6a9218f106f63d94$export$103f41d1f3bf374e;
module.exports["DISMISS_FAILED"] = $6a9218f106f63d94$export$6d3088110036f124;
module.exports["REASONS_BUTTON_CLICKED"] = $6a9218f106f63d94$export$5595c6967e83d351;
module.exports["REASONS_MODAL_SHOWN"] = $6a9218f106f63d94$export$ff50ad60f08a4bc0;
module.exports["REASONS_MODAL_DISMISSED"] = $6a9218f106f63d94$export$6bd2d8eacca15ce1;
module.exports["FLAG_DISMISSED"] = $6a9218f106f63d94$export$5c5fc6956b7600ea;

});

parcelRegister("kSW34", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e3ec5bbd654613$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");

function $07e3ec5bbd654613$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $7TH2w.SCREEN_EVENT_TYPE),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("h9hzU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fRta5 = parcelRequire("fRta5");


var $9c9yH = parcelRequire("9c9yH");


var $8L1Fu = parcelRequire("8L1Fu");

function $80d3df06c6f273d3$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $8L1Fu.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $fRta5.FLAG_DISMISSED:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((itemId)=>{
        return new (0, $9c9yH.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}
module.exports["useAdControlProvider"] = $80d3df06c6f273d3$export$450072b04d50916;

});

parcelRegister("9c9yH", function(module, exports) {
class $99f724af69d7c626$export$2e2bcd8739ae039 {
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
}
module.exports["default"] = $99f724af69d7c626$export$2e2bcd8739ae039;

});

parcelRegister("8L1Fu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $35IL4 = parcelRequire("35IL4");

function $d1d018053c996795$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $35IL4.AdControlContext));
}
module.exports["useAdControlContext"] = $d1d018053c996795$export$4e82dc865a56141b;

});

parcelRegister("35IL4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1dZ5H = parcelRequire("1dZ5H");

const $8a2d05ab8b5622c4$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    state: {
        ...(0, $1dZ5H.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});
module.exports["AdControlContext"] = $8a2d05ab8b5622c4$export$554b2f9bd0a293df;

});

parcelRegister("1dZ5H", function(module, exports) {
const $abc4c02fc3dda9d3$export$22776e7a42f7089d = {
    flags: new Map()
};
const $abc4c02fc3dda9d3$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};
module.exports["initialAdControlProviderState"] = $abc4c02fc3dda9d3$export$22776e7a42f7089d;
module.exports["adControlProviderReducer"] = $abc4c02fc3dda9d3$export$5f3557676ca801eb;

});

parcelRegister("2zUpm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $35IL4 = parcelRequire("35IL4");


var $1dZ5H = parcelRequire("1dZ5H");


var $kL1O8 = parcelRequire("kL1O8");


var $85Wse = parcelRequire("85Wse");


var $jC7C7 = parcelRequire("jC7C7");

const $f0fb9a90e64cd61d$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer((0, $1dZ5H.adControlProviderReducer), (0, $1dZ5H.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kL1O8.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $35IL4.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $jC7C7.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $85Wse.default), {})
            ]
        })
    });
};
var $f0fb9a90e64cd61d$export$2e2bcd8739ae039 = $f0fb9a90e64cd61d$var$AdControlProvider;
module.exports["default"] = $f0fb9a90e64cd61d$export$2e2bcd8739ae039;

});

parcelRegister("kL1O8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $dqUnB = parcelRequire("dqUnB");


var $i9bNu = parcelRequire("i9bNu");

const $b308713f20b40665$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $i9bNu.default),
        loaderFn: (0, $dqUnB.fetchMessagesForLocale),
        children: children
    });
};
var $b308713f20b40665$export$2e2bcd8739ae039 = $b308713f20b40665$var$ActIntlProvider;
module.exports["default"] = $b308713f20b40665$export$2e2bcd8739ae039;

});

parcelRegister("dqUnB", function(module, exports) {

var $k1MFX = parcelRequire("k1MFX");


var $i9bNu = parcelRequire("i9bNu");

const $06c066c00d1ae0fc$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $06c066c00d1ae0fc$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($06c066c00d1ae0fc$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $k1MFX.locales)) {
            const messages = await (0, $k1MFX.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $k1MFX.locales)) {
            const messages = await (0, $k1MFX.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $i9bNu.default;
};
module.exports["fetchMessagesForLocale"] = $06c066c00d1ae0fc$export$2b153a2030b0feb2;

});

parcelRegister("k1MFX", function(module, exports) {


























const $21a44ec23de25ffe$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("4eMQd")),
    da: ()=>(parcelRequire("6xcXa")),
    de: ()=>(parcelRequire("ge2eI")),
    en_GB: ()=>(parcelRequire("kFjnq")),
    en_ZZ: ()=>(parcelRequire("bxcHY")),
    en: ()=>Promise.resolve((parcelRequire("i9bNu"))),
    es: ()=>(parcelRequire("lRPwm")),
    fi: ()=>(parcelRequire("ebB32")),
    fr: ()=>(parcelRequire("5uZHO")),
    hu: ()=>(parcelRequire("1JxHc")),
    it: ()=>(parcelRequire("7IBBJ")),
    ja: ()=>(parcelRequire("jrej6")),
    ko: ()=>(parcelRequire("1JX7s")),
    nb: ()=>(parcelRequire("jMOHK")),
    nl: ()=>(parcelRequire("9nNiG")),
    pl: ()=>(parcelRequire("5BSNH")),
    pt_BR: ()=>(parcelRequire("jm3ex")),
    ru: ()=>(parcelRequire("eZ80I")),
    sv: ()=>(parcelRequire("3ZEFq")),
    th: ()=>(parcelRequire("kEPri")),
    tr: ()=>(parcelRequire("h4TBY")),
    uk: ()=>(parcelRequire("9eHWu")),
    vi: ()=>(parcelRequire("a2Nsn")),
    zh_TW: ()=>(parcelRequire("9Ihm1")),
    zh: ()=>(parcelRequire("S8Ege"))
};
module.exports["locales"] = $21a44ec23de25ffe$export$df1c34db1371eeed;

});

parcelRegister("i9bNu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3654660649c0d4bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3654660649c0d4bb$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("4eMQd", function(module, exports) {

let $315e5b0eff786d5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $315e5b0eff786d5a$var$load("3FT39").then(()=>parcelRequire('4Yleb'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("6xcXa", function(module, exports) {

let $4c1fdf6b12b37a17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c1fdf6b12b37a17$var$load("7QoTg").then(()=>parcelRequire('jDakE'));

});

parcelRegister("ge2eI", function(module, exports) {

let $bcffb037722ea990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcffb037722ea990$var$load("d1Lrf").then(()=>parcelRequire('6RK0u'));

});

parcelRegister("kFjnq", function(module, exports) {

let $f0b6aacbdb40b5ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0b6aacbdb40b5ad$var$load("kM5GB").then(()=>parcelRequire('kzcZp'));

});

parcelRegister("bxcHY", function(module, exports) {

let $865ca262a9055aad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $865ca262a9055aad$var$load("5506N").then(()=>parcelRequire('33OOq'));

});

parcelRegister("lRPwm", function(module, exports) {

let $feb683360f3c545f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb683360f3c545f$var$load("7ioy0").then(()=>parcelRequire('gMkb6'));

});

parcelRegister("ebB32", function(module, exports) {

let $a53ed4b86a0b887f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a53ed4b86a0b887f$var$load("kZ6zs").then(()=>parcelRequire('1OjJD'));

});

parcelRegister("5uZHO", function(module, exports) {

let $400f9e8fda48b9de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $400f9e8fda48b9de$var$load("phbpE").then(()=>parcelRequire('jvMdy'));

});

parcelRegister("1JxHc", function(module, exports) {

let $143421b071e9854c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $143421b071e9854c$var$load("6pKhl").then(()=>parcelRequire('gVnbl'));

});

parcelRegister("7IBBJ", function(module, exports) {

let $59e9d08f20e946d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59e9d08f20e946d5$var$load("hzLOt").then(()=>parcelRequire('d0lkZ'));

});

parcelRegister("jrej6", function(module, exports) {

let $e26ba30433a0b5bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e26ba30433a0b5bf$var$load("1M8mW").then(()=>parcelRequire('4TGbq'));

});

parcelRegister("1JX7s", function(module, exports) {

let $1447da49ec6cfdc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1447da49ec6cfdc7$var$load("eHQAY").then(()=>parcelRequire('hGfMv'));

});

parcelRegister("jMOHK", function(module, exports) {

let $e679d4de95e3657e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e679d4de95e3657e$var$load("8exPB").then(()=>parcelRequire('aYgYT'));

});

parcelRegister("9nNiG", function(module, exports) {

let $6d4c8109597ab866$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d4c8109597ab866$var$load("knfAP").then(()=>parcelRequire('2GadI'));

});

parcelRegister("5BSNH", function(module, exports) {

let $415aeabc10236ce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $415aeabc10236ce4$var$load("ljRXP").then(()=>parcelRequire('eoRvM'));

});

parcelRegister("jm3ex", function(module, exports) {

let $e172947b685f7336$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e172947b685f7336$var$load("bEb8c").then(()=>parcelRequire('5mSqI'));

});

parcelRegister("eZ80I", function(module, exports) {

let $ae8cf9e6f09d976b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae8cf9e6f09d976b$var$load("c7JYF").then(()=>parcelRequire('5zX31'));

});

parcelRegister("3ZEFq", function(module, exports) {

let $2e869d3f88a75530$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e869d3f88a75530$var$load("ari8V").then(()=>parcelRequire('j4Pzu'));

});

parcelRegister("kEPri", function(module, exports) {

let $f09f71dda87efcbd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f09f71dda87efcbd$var$load("kfrHX").then(()=>parcelRequire('bdGVV'));

});

parcelRegister("h4TBY", function(module, exports) {

let $c6edf2b09dd62781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6edf2b09dd62781$var$load("aWToy").then(()=>parcelRequire('bg9up'));

});

parcelRegister("9eHWu", function(module, exports) {

let $6b9781e1cddd22ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b9781e1cddd22ce$var$load("4ns5x").then(()=>parcelRequire('jG5jM'));

});

parcelRegister("a2Nsn", function(module, exports) {

let $7500745ca11310a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7500745ca11310a3$var$load("7bfAn").then(()=>parcelRequire('jgloM'));

});

parcelRegister("9Ihm1", function(module, exports) {

let $7125af4652facd67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7125af4652facd67$var$load("gftgT").then(()=>parcelRequire('i0bIF'));

});

parcelRegister("S8Ege", function(module, exports) {

let $0a2bc0a564e10417$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0a2bc0a564e10417$var$load("6YVlG").then(()=>parcelRequire('4a8Ly'));

});

parcelRegister("85Wse", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $aD1SW = parcelRequire("aD1SW");

var $6uGcC = parcelRequire("6uGcC");


var $imt6g = parcelRequire("imt6g");


var $gdv5Z = parcelRequire("gdv5Z");


var $6fnsQ = parcelRequire("6fnsQ");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");


var $2bASh = parcelRequire("2bASh");

const $0f8daac9763b8054$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $0f8daac9763b8054$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $0f8daac9763b8054$var$DismissalFlagGroup = ()=>{
    (0, $2bASh.overridePortalIndex)($0f8daac9763b8054$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $fRta5.FLAG_DISMISSED), createInteractedUIEvent($0f8daac9763b8054$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                id: $0f8daac9763b8054$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                        label: "Success",
                        spacing: "spacious",
                        color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`
                    }),
                    title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                        ...(0, $7R3FL.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                        ...(0, $7R3FL.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $0f8daac9763b8054$export$2e2bcd8739ae039 = $0f8daac9763b8054$var$DismissalFlagGroup;
module.exports["default"] = $0f8daac9763b8054$export$2e2bcd8739ae039;

});

parcelRegister("7R3FL", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $c156cf06b085a120$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    notInterested: {
        id: "act.action.notInterested.button.text",
        defaultMessage: "Not interested"
    },
    notInterestedFlag: {
        id: "act.action.notInterestedFlag.flag.text",
        defaultMessage: "Got it, thanks for letting us know"
    },
    showReasons: {
        id: "act.action.showReasons.common.text",
        defaultMessage: "Why am I seeing this?"
    },
    dismissalMessage: {
        id: "act.action.dismissalMessage.common.text",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalOkButton: {
        id: "act.action.reasonsModalOkButton.common.text",
        defaultMessage: "OK"
    }
});
module.exports["messages"] = $c156cf06b085a120$export$defe85febe8b728c;

});

parcelRegister("2bASh", function(module, exports) {
const $5cf66c7a3cd119b9$export$335243096683aa37 = 900;
function $5cf66c7a3cd119b9$export$61df98316049b30(elementId, index = $5cf66c7a3cd119b9$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $5cf66c7a3cd119b9$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $5cf66c7a3cd119b9$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $5cf66c7a3cd119b9$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$5cf66c7a3cd119b9$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}
module.exports["DEFAULT_PORTAL_OVERRIDE_INDEX"] = $5cf66c7a3cd119b9$export$335243096683aa37;
module.exports["overridePortalIndex"] = $5cf66c7a3cd119b9$export$61df98316049b30;

});

parcelRegister("jC7C7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");


var $2bASh = parcelRequire("2bASh");

const $139ac0b427a5c906$var$adControlScreenName = 'adControlsReasonsModal';
const $139ac0b427a5c906$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $139ac0b427a5c906$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $2bASh.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $kSW34.default)();
    const isMounted = (0, $42omo.useRef)(false);
    const eventDispatcherRef = (0, $42omo.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $42omo.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $fRta5.REASONS_MODAL_SHOWN), createScreenUIEvent($139ac0b427a5c906$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $fRta5.REASONS_MODAL_DISMISSED), createScreenUIEvent($139ac0b427a5c906$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $2bASh.overridePortalIndex)($139ac0b427a5c906$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                id: $139ac0b427a5c906$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        hasCloseButton: hasCloseButton,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                ...(0, $7R3FL.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                ...(0, $7R3FL.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $139ac0b427a5c906$export$2e2bcd8739ae039 = $139ac0b427a5c906$var$ReasonsModal;
module.exports["default"] = $139ac0b427a5c906$export$2e2bcd8739ae039;

});

parcelRegister("3ylo6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $dAYOx = parcelRequire("dAYOx");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");

const $08a2895c8eb1cea2$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $08a2895c8eb1cea2$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $fRta5.DISMISS_STARTED), createInteractedUIEvent($08a2895c8eb1cea2$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $fRta5.DISMISS_SUCCEEDED));
        } catch (e) {
            eventDispatcher.dispatchError((0, $fRta5.DISMISS_FAILED), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...(0, $7R3FL.messages).notInterested
        })
    });
};
var $08a2895c8eb1cea2$export$2e2bcd8739ae039 = $08a2895c8eb1cea2$var$DismissalButton;
module.exports["default"] = $08a2895c8eb1cea2$export$2e2bcd8739ae039;

});

parcelRegister("hEz36", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $dAYOx = parcelRequire("dAYOx");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");

const $3b87ab993ce1d1b1$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $3b87ab993ce1d1b1$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $fRta5.REASONS_BUTTON_CLICKED), createInteractedUIEvent($3b87ab993ce1d1b1$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...(0, $7R3FL.messages).showReasons
        })
    });
};
var $3b87ab993ce1d1b1$export$2e2bcd8739ae039 = $3b87ab993ce1d1b1$var$ReasonsButton;
module.exports["default"] = $3b87ab993ce1d1b1$export$2e2bcd8739ae039;

});


//# sourceMappingURL=LoomCrossFlowPopupComponent.92cb69b2.js.map
